import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { removeError, reportError } from './error-log.reducer'
import { delay, mergeMap } from 'rxjs/operators'

const ttlMs = 10 * 60 * 1000

@Injectable()
export class ErrorLogEffects {
  expireErrorLogs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(reportError),
      delay(ttlMs),
      mergeMap(action => [removeError(action.payload.id)]),
    )
  })

  constructor(private readonly actions$: Actions) {}
}
